import React, { memo, ReactNode, useMemo, useState } from 'react'
import { IReloadWrapperContext, ReloadWrapperContext } from './ReloadWrapper.context'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'

interface Props {
  children: ReactNode
  reloadTimeout?: number
}

const ReloadWrapperComponent = ({ children, reloadTimeout = 300 }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const reload = () => {
    setIsLoading(true)

    setTimeout(() => {
      setIsLoading(false)
    }, reloadTimeout)
  }

  const reloadWrapperContextValue = useMemo<IReloadWrapperContext>(() => {
    return {
      reload,
    }
  }, [reload])

  return (
    <ReloadWrapperContext.Provider value={reloadWrapperContextValue}>
      {isLoading ? <FullScreenLoader /> : children}
    </ReloadWrapperContext.Provider>
  )
}

export const ReloadWrapper = memo(ReloadWrapperComponent)
